<template>
	<div v-if="badgeList.length" class="mb-2">
		<div class="mb-3">
			<a @click.prevent="clearBadges" class="small" href>Clear All</a>
		</div>

		<b-badge
			v-for="badge in badgeList"
			:key="badge.key"
			class="py-2 px-3 mr-2 mb-2 font-weight-normal"
			pill
		>
			<strong>{{ badge.label }}</strong
			>: {{ badge.value }}
			<a @click.prevent="removeBadge(badge)" href>
				<b-icon
					icon="x"
					font-scale="1.5"
					variant="danger"
					class="ml-1"
				></b-icon>
			</a>
		</b-badge>
	</div>
</template>

<script>
import { getUniqueID } from "./../utils/arrays";

export default {
	name: "drv-filter-badges",
	props: {
		filters: {
			type: Object,
		},
	},
	computed: {
		badgeList() {
			let list = [];

			Object.entries(this.filters)
				.filter((item) => {
					return item[1] ? true : false;
				})
				.forEach((item) => {
					if (Array.isArray(item[1]))
						item[1].forEach((litem) => {
							list.push({
								key: getUniqueID(`filter-${item[0]}`),
								name: item[0],
								label: item[0].replace(/_/g, " "),
								value: litem,
							});
						});
					else
						list.push({
							key: getUniqueID(`filter-${item[0]}`),
							name: item[0],
							label: item[0].replace(/_/g, " "),
							value: item[1].replace(",", " to "),
						});
				});

			return list;
		},
	},
	methods: {
		clearBadges() {
			this.$emit("remove-filter", "*");
		},
		removeBadge(badge) {
			this.$emit("remove-filter", {
				name: badge.name,
				value: badge.value.includes(" to ")
					? badge.value.replace(" to ", ",")
					: badge.value,
			});
		},
	},
};
</script>
